import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './society-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class SocietyDetailComponent extends AbstractCollectionDirective {}
